/**
 * Custom smooth scroll behavior for anchor links
 * Centers the target element in the viewport when scrolling
 */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href]:not([href=""])').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');

      if (href && href.startsWith('#') && href.length > 1) {
        e.preventDefault();

        const target = document.querySelector(href);

        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }
    });
  });
});
